import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { cmdApi, saveToken } from "../api";
import { useCmdAuth } from "../contexts/CmdAuthContext";

export default function CmdAcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const { refresh } = useCmdAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setErr("Missing invite token."); return; }
    cmdApi.get(`/access/invites/${token}`).then(({ data }) => {
      setInfo(data); setName(data.name || "");
    }).catch((ex) => setErr(ex?.response?.data?.detail || "Invite not found."));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setErr("Passwords do not match."); return; }
    setBusy(true); setErr("");
    try {
      const { data } = await cmdApi.post("/access/invites/accept", { token, name, password });
      saveToken(data.access_token);
      await refresh();
      navigate("/cmd", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Could not accept invite.");
    } finally { setBusy(false); }
  };

  return (
    <div className="cmd-root">
      <div className="cmd-auth-wrap">
        <form className="cmd-auth-card" onSubmit={submit} data-testid="cmd-accept-form">
          <h1>Join EEPL Command Room</h1>
          {info ? (
            <>
              <p className="sub">Invited as <strong>{info.role}</strong>{info.verticals?.length ? ` for ${info.verticals.join(", ")}` : ""}.</p>
              <div className="cmd-field"><label>Full name</label>
                <input className="cmd-input" value={name} required onChange={(e) => setName(e.target.value)} data-testid="cmd-accept-name" /></div>
              <div className="cmd-field"><label>Email</label>
                <input className="cmd-input" value={info.email} disabled data-testid="cmd-accept-email" /></div>
              <div className="cmd-field"><label>Password (min 8)</label>
                <input className="cmd-input" type="password" value={password} minLength={8} required
                  onChange={(e) => setPassword(e.target.value)} data-testid="cmd-accept-password" /></div>
              <div className="cmd-field"><label>Confirm password</label>
                <input className="cmd-input" type="password" value={confirm} required
                  onChange={(e) => setConfirm(e.target.value)} data-testid="cmd-accept-confirm" /></div>
              {err && <div className="cmd-error" data-testid="cmd-accept-error">{err}</div>}
              <button className="cmd-btn cmd-btn-primary" type="submit" disabled={busy} style={{ width: "100%", marginTop: 8 }} data-testid="cmd-accept-submit">
                {busy ? "Setting up…" : "Set password and sign in"}
              </button>
            </>
          ) : (
            <p className="cmd-muted">{err || "Loading invite…"}</p>
          )}
        </form>
      </div>
    </div>
  );
}
